import LoadingShimmerMapper from './LoadingShimmerMapper';
export default LoadingShimmerMapper;
